// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Site_Image/master/ecommerce.png",
    title: "E-Commerce Backend API",
    description:
      "Develped API which we can use for fronted for web and android with handling authentication, authrization, products, handle cart and place order ",
    tech_stack: "Node, Express, API, JWT, bycrypt, mongodb",
    github_url: "https://github.com/saurabh-kud/E-commerce-Full-Stack",
    demo_url: "https://documenter.getpostman.com/view/25265039/2s8Z76vUt3",
  },
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Site_Image/master/leave.png",
    title: "Lpu-Leave-Automation",
    description:
      "Made a Automation and launch a website to take leave from lpu ums withing second ",
    tech_stack: "Node, Puppeter, AWS, Express, React",
    github_url: "https://github.com/lpuleave/lpuleave.github.io",
    demo_url: "https://lpuleave.me/",
  },
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Sangeet-app/master/src/Data/mockup/mockup.png",
    title: "Sangeet-app",
    description: "created music player ui like spotify, gana",
    tech_stack: "Reactjs, Css",
    github_url: "https://github.com/saurabh-kud/Sangeet-app",
    demo_url: "https://sangeet-app.netlify.app/",
  },
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Contact-app/main/public/mokup.png",
    title: "Contact-app",
    description: "a contact-manager react app with backend and API features",
    tech_stack: "Reactjs, Css, React-Router-Dom, Rest-API, Axios",
    github_url: "https://github.com/saurabh-kud/Contact-app",
    demo_url: "https://contact-manager-ap.netlify.app/",
  },

  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Site_Image/master/portfolio.png",
    title: "Portfolio",
    description: "I made my own personal portfolio website.",
    tech_stack: "Reactjs, Css",
    github_url: "https://github.com/saurabh-kud/Portfolio",
    demo_url: "https://saurabh-kud.netlify.app/",
  },
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Site_Image/master/Banking.png",
    title: "Banking web app frontend",
    description: "created simple banking web app frontend",
    tech_stack: "Html, Css, Javascript",
    github_url: "https://github.com/saurabh-kud/Banking-Frontend",
    demo_url: "https://banking-frontend.netlify.app/",
  },
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Site_Image/master/Multiplayer.png",
    title: "2 Player basic Game",
    description:
      "created simple game play site where two player can play like ludo ",
    tech_stack: "Html, Css, Javascript",
    github_url: "https://github.com/saurabh-kud/Multiplay-Game",
    demo_url: "https://multiplay-game.netlify.app/",
  },
  {
    img: "https://raw.githubusercontent.com/saurabh-kud/Site_Image/master/Guess_number.png",
    title: "Guess the number",
    description:
      "created simple game play site where we have to guess the number generated by system with dark mode support",
    tech_stack: "Html, Css, Javascript",
    github_url: "https://github.com/saurabh-kud/Guess-Number",
    demo_url: "https://guess-numbe.netlify.app/",
  },
];
// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },

  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/responsive.svg",
    name: "Responsive",
  },
];
